import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-stopped-moving-svg',
  imports: [],
  templateUrl: './stopped-moving-svg.component.html',
  styleUrl: './stopped-moving-svg.component.css'
})
export class StoppedMovingSvgComponent {
  @Input() width: string = '50'
  @Input() height: string = '50'
}
